import React, { useState, useEffect, useRef } from "react";
import { Settings, DateTime } from "luxon";
import { Link } from "react-router-dom";
import useTranslation from "../hooks/useTranslation";
import useNotification from "../hooks/useNotification";
import { Store } from "../store";
import Cookies from "js-cookie";
import useResponsive from "../hooks/useResponsive";

const SuperHeader = () => {
  const { cookies, config } = Store.useState(s => s);
  const { t, i18n } = useTranslation();
  const { addNotification } = useNotification();
  const settings = config.eshop.theme.selected.settings;
  const { isMobile } = useResponsive({ maxWidth: settings?.mobileBreakpoint });

  const openingHours = config.modules.find(m => m.id === "information").data.openings;
  const hasOpeningHours = openingHours && openingHours.length;
  const dayIndex = DateTime.now().weekday;
  const openings = openingHours ? openingHours[dayIndex - 1] : null;

  const backgroundColor = settings.superHeader?.backgroundColor;

  return <div id="superHeader" className={`${isMobile ? "mobile" : ""}`} style={{ backgroundColor: backgroundColor ? `var(--${backgroundColor.id})` : "inherit" }}>
    <div className="content">
      <div className="left">
        {hasOpeningHours ? <>
          {openings && openings.length ? (
            <p>
              {t("openToday")}:{" "}
              {openings.map((o, i) => (
                <span key={o.from}>
                  {DateTime.fromISO(o.from, "HH:mm").toFormat("HH:mm")} - {DateTime.fromISO(o.to, "HH:mm").toFormat("HH:mm")}
                  {i < openings.length - 1 ? " | " : null}
                </span>
              ))}
            </p>
          ) : (
            <p>{t("closedToday")}</p>
          )} </> : null }
      </div>
      <div className="right">
        <button type="button" className="openCookies" onClick={e => cookies.openModal()}>Cookies</button>
        <Link to="/shipping">{t("shipping")}</Link>
        <Link to="/legal">{t("termsAndConditions")}</Link>
        <LanguageSelector config={config} i18n={i18n} addNotification={addNotification} />
      </div>
    </div>
  </div>;
};

const LanguageSelector = ({ config, i18n, addNotification }) => {
  const currentLanguage = i18n.language;
  const languages = config.eshop.preferences.languages.whitelist;
  const [open, setOpen] = useState(false);
  const localRef = useRef();

  const handleClickOutside = event => {
    if (localRef.current && !localRef.current.contains(event.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => document.removeEventListener("click", handleClickOutside, true);
  }, []);

  const handleChangeLanguage = locale => {
    Cookies.set("locale", locale, { expires: 365 });
    Settings.defaultLocale = locale;
    i18n.changeLanguage(locale, (_, newt) => {
      addNotification({ ok: 1, message: newt("languageUpdate") });
    });
  };

  useEffect(() => {
    if (languages.indexOf(currentLanguage) === -1) {
      if (languages.length) handleChangeLanguage(languages[0]);
      else handleChangeLanguage("en");
    }
  }, [config.eshop.preferences.languages.whitelist, currentLanguage]);

  if (languages.length < 2) return null;

  return (
    <div className="languageSelector" ref={localRef}>
      <div className="current">
        <button onClick={e => setOpen(!open)} className="current">
          {currentLanguage}
          <i className="cg-icon-down" />
        </button>
      </div>
      {open ? <div className="entries" style={{ backgroundColor: `var(--${config.eshop.theme?.selected?.settings?.superHeader?.backgroundColor?.id})` }}>
        {languages.filter(l => l !== currentLanguage).map(l => <button key={l}
          className={"entry" + (i18n.language === l ? "selected" : "")}
          type="button"
          onClick={e => { setOpen(false); handleChangeLanguage(l); }}>
          {l}
        </button>)}
      </div> : null}
    </div>);
};

export default SuperHeader;
